module.exports = __webpack_public_path__ + "static/media/ice4.93665766.webp";